<template>
  <div class="wait-container">
    <LoadingIcon :size="size" :fillColor="fillColor" />
    <p class="dim">
      {{ $t('connecting') }}<br />
      {{ $t('please_wait') }}
    </p>
  </div>
</template>

<script setup>
import LoadingIcon from '@/components/icons/IconLoading.vue';
const props = defineProps({
  fillColor: {
    type: String,
    default: 'var(--primary)', // 기본값 설정
  },
  size: {
    type: String,
    default: '2rem',
  },
});
</script>

<style scoped lang="scss">
.wait-container {
  height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
}
</style>
